import { WoltLogo, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';
import { FeatureType } from 'common/types';
import UserDropdown from 'modules/header/components/UserDropdown';

export type Props = {
  selectedVenueSlug?: string;
  selectedFeature?: FeatureType;
  hideVenueSelector: boolean;
};

const Root = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: flex;
  height: 100px;
  padding: 10px 24px;
  background-color: ${cssThemedValue('textPrimary')};
  width: 100%;
  z-index: 1000;
  justify-content: space-between;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: ${({ isMobile }) => (isMobile ? '-250px' : '-230px')};
    left: ${({ isMobile }) => (isMobile ? '-20%' : '-10%')};
    width: ${({ isMobile }) => (isMobile ? '140%' : '120%')}; /* make it smoother */
    height: 280px;
    background-color: ${cssThemedValue('surfaceMain')};
    border-radius: ${({ isMobile }) => (isMobile ? '50% / 15%' : '50% / 40%')}; /* ellipse */
    z-index: -1;
  }
`;

const StyledWoltLogo = styled(WoltLogo)`
  height: 16px;
  fill: ${cssThemedValue('surfaceMain')};
`;

const OnboardingPageHeader = () => {
  const isMobile = useIsMobile();

  return (
    <Root isMobile={isMobile}>
      <StyledWoltLogo />
      <UserDropdown />
    </Root>
  );
};

export default OnboardingPageHeader;
